(() => {
  const templateSelector = '#SpazioilUrgencyTemplate';
  const productSelector = '#MainContent [id^="MainProduct-"]';
  const salesRootSelector = '[data-spazioil-product-sales]';
  const countdownRootSelector = '[data-spazioil-product-countdown]';

  const integer = (value, fallback) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const randomBetween = (first, second) => {
    const min = Math.min(first, second);
    const max = Math.max(first, second);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const renderSalesMessage = (target, message, values) => {
    const parts = message.split(/(\[sold\]|\[hours\])/g);
    target.replaceChildren();

    parts.forEach((part) => {
      if (part === '[sold]' || part === '[hours]') {
        const number = document.createElement('strong');
        number.className = 'spazioil-product-urgency__number';
        number.textContent = part === '[sold]' ? values.sold : values.hours;
        target.append(number);
      } else if (part) {
        target.append(document.createTextNode(part));
      }
    });
  };

  const initializeSales = (counter) => {
    const values = {
      sold: randomBetween(
        Math.max(0, integer(counter.dataset.minSold, 1)),
        Math.max(0, integer(counter.dataset.maxSold, 8))
      ),
      hours: randomBetween(
        Math.max(1, integer(counter.dataset.minHours, 24)),
        Math.max(1, integer(counter.dataset.maxHours, 96))
      )
    };
    const target = counter.querySelector('[data-urgency-sales-text]');
    if (target) renderSalesMessage(target, counter.dataset.message || '[sold] sold in last [hours] hours', values);
  };

  const countdownEndTime = (countdown, productId, duration) => {
    const now = Date.now();
    if (countdown.dataset.resetMode === 'page') return now + duration * 1000;

    const key = `spazioil-countdown-${productId}-${duration}`;
    try {
      const stored = integer(window.sessionStorage.getItem(key), 0);
      if (stored > now) return stored;
      const endTime = now + duration * 1000;
      window.sessionStorage.setItem(key, String(endTime));
      return endTime;
    } catch (error) {
      return now + duration * 1000;
    }
  };

  const pad = (value) => String(value).padStart(2, '0');

  const initializeCountdown = (countdown, productId) => {
    const duration = Math.max(60, integer(countdown.dataset.duration, 14400));
    const endTime = countdownEndTime(countdown, productId, duration);
    const timer = countdown.querySelector('[data-urgency-timer]');
    const hoursTarget = countdown.querySelector('[data-urgency-hours]');
    const minutesTarget = countdown.querySelector('[data-urgency-minutes]');
    const secondsTarget = countdown.querySelector('[data-urgency-seconds]');
    let intervalId;

    const update = () => {
      if (!countdown.isConnected) {
        window.clearInterval(intervalId);
        return;
      }

      const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;

      if (hoursTarget) hoursTarget.textContent = pad(hours);
      if (minutesTarget) minutesTarget.textContent = pad(minutes);
      if (secondsTarget) secondsTarget.textContent = pad(seconds);
      if (timer) timer.setAttribute('aria-label', `${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);

      if (remaining === 0) {
        window.clearInterval(intervalId);
        countdown.classList.add('spazioil-product-urgency__countdown--expired');
        countdown.textContent = countdown.dataset.expiredText || 'Offer ended';
      }
    };

    update();
    intervalId = window.setInterval(update, 1000);
  };

  const mount = () => {
    const template = document.querySelector(templateSelector);
    const product = document.querySelector(productSelector);
    if (!template || !product) return;

    const price = product.querySelector('.product__info-container .price-wrapper[id^="price-"]');
    const productForm = product.querySelector('product-form.product-form');

    const fragment = template.content.cloneNode(true);
    const salesRoot = fragment.querySelector(salesRootSelector);
    const countdownRoot = fragment.querySelector(countdownRootSelector);

    if (salesRoot && price && !document.querySelector(salesRootSelector)) {
      const sales = salesRoot.querySelector('[data-urgency-sales]');
      if (sales) initializeSales(sales);
      price.after(salesRoot);
    }

    if (countdownRoot && productForm && !product.querySelector('spazioil-early-access') && !document.querySelector(countdownRootSelector)) {
      const countdown = countdownRoot.querySelector('[data-urgency-countdown]');
      if (countdown) initializeCountdown(countdown, countdownRoot.dataset.productId || 'product');
      productForm.before(countdownRoot);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', mount);
})();
